import type { DocumentIndexingRefreshMode } from "@shared/types/corpus";

/** The label and the one-line help that say what a mode covers. */
export interface DocumentIndexingRefreshModeCopy {
  label: string;
  help: string;
}

/** What each mode is called and explained as, in the New-job form. */
export const DOCUMENT_INDEXING_REFRESH_MODE_COPY: Record<
  DocumentIndexingRefreshMode,
  DocumentIndexingRefreshModeCopy
> = {
  untagged: {
    label: "Only documents without fields",
    help: "Documents that carry no field tags yet — the usual run after the skeleton gained prefixes",
  },
  full: {
    label: "Every document",
    help: "All documents still in the corpus, revoked ones excluded — also fills in the subjects, main subjects and publication types stored before they were kept",
  },
};

/** The modes in the order the New-job form offers them. */
export const DOCUMENT_INDEXING_REFRESH_MODE_VALUES: readonly DocumentIndexingRefreshMode[] = [
  "untagged",
  "full",
];
